import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import './onboarding.css';

export default function OnboardingBanner({ step, title, description }) {
  return (
    <div className="onboarding-page-banner">
      <div className="onboarding-page-banner-icon">
        <FontAwesomeIcon icon={faInfoCircle} />
      </div>
      <div className="onboarding-page-banner-content">
        <div className="onboarding-page-banner-step">Étape {step}</div>
        <h3 className="onboarding-page-banner-title">{title}</h3>
        <p className="onboarding-page-banner-description">{description}</p>
      </div>
    </div>
  );
}

